// Módulo: Lista de Lançamentos
// Responsável por buscar e exibir a tabela de lançamentos e gerenciar filtros.

window.FazendaRP = window.FazendaRP || {};
window.FazendaRP.Pages = window.FazendaRP.Pages || {};
window.FazendaRP.Pages.financeiro = window.FazendaRP.Pages.financeiro || {};

Object.assign(window.FazendaRP.Pages.financeiro, {

    renderListaLancamentos: async function (container) {
        container.innerHTML = '<div style="text-align:center; padding:30px;"><i class="fas fa-spinner fa-spin"></i> Carregando lançamentos...</div>';

        // Fetch Data
        const { data: lancamentos, error } = await window.FazendaRP.supabase
            .from('financeiro_lancamentos')
            .select(`
                id, num_doc, data_emissao, data_vencimento, data_pagamento, descricao, valor, valor_documento, status, tipo, categoria, detalhes,
                financeiro_contas (nome), anexos,
                parceiros (nome)
            `)
            .order('data_emissao', { ascending: false });

        if (error) {
            console.error(error);
            container.innerHTML = `<div style="color:red; text-align:center; padding: 20px;">Erro ao carregar: ${error.message}</div>`;
            return;
        }

        container.innerHTML = `
            <div class="data-table-container">
                <div class="action-bar">
                    <div class="filter-group" style="display:flex; align-items:center; gap:10px; flex-wrap:wrap;">
                        <button id="btn-print-lanc" class="btn btn-secondary" style="margin-right: 15px;">
                            <i class="fas fa-print"></i> Imprimir
                        </button>
                        <button id="btn-export-lanc" class="btn btn-secondary" style="margin-right: 15px; background-color: #059669; color: white; border:1px solid #059669;">
                            <i class="fas fa-file-excel"></i> Exportar
                        </button>
                        <input type="date" id="filtro-data-de" placeholder="De">
                        <input type="date" id="filtro-data-ate" placeholder="Até">
                        <input type="text" id="filtro-busca" placeholder="Buscar parceiro, doc ou valor..." style="min-width: 250px;">
                        
                    </div>
                    <div>
                         <button class="btn btn-primary" id="btn-go-novo">+ Novo Lançamento</button>
                    </div>
                </div>
                
                <table class="data-table">
                    <thead>
                        <tr>
                            <th>Emissão</th>
                            <th>Nº Doc</th>
                            <th>Descrição</th>
                            <th>Parceiro</th>
                            <th>Categoria</th>
                            <th>Conta</th>
                            <th>Valor</th>
                            <th>Status</th>
                            <th width="40" style="text-align:center;" title="Documento Físico Arquivado?">Arq.</th>
                            <th width="80" style="text-align:right;">Ações</th>
                        </tr>
                    </thead>
                    <tbody id="lista-lancamentos-body">
                        ${this.renderRowsHTML(lancamentos)}
                    </tbody>
                </table>
            </div>
        `;

        const btn = document.getElementById('btn-go-novo');
        if (btn) {
            btn.addEventListener('click', () => {
                // Clear State on New
                if (window.FazendaRP.Pages.financeiro) {
                    window.FazendaRP.Pages.financeiro._pendingEditId = null;
                    window.FazendaRP.Pages.financeiro._editingId = null;
                    window.FazendaRP.Pages.financeiro.currentAttachments = [];
                }

                this.renderTabContent('novo-lancamento');
                document.querySelectorAll('.submenu-item').forEach(t => t.classList.remove('active'));
                document.querySelector('.submenu-item[data-tab="novo-lancamento"]')?.classList.add('active');
            });
        }

        // Filtros (Busca + Button Toggle + Date)
        const inputBusca = document.getElementById('filtro-busca');
        const inputDe = document.getElementById('filtro-data-de');
        const inputAte = document.getElementById('filtro-data-ate');

        const btnFiltroArq = document.getElementById('btn-filtro-pendente');
        const btnInbox = document.getElementById('btn-inbox-sefaz');
        const btnCert = document.getElementById('btn-certificados');
        const btnPrint = document.getElementById('btn-print-lanc');

        let onlyPending = false; // Internal State
        let currentList = lancamentos || [];

        const aplicarFiltros = () => {
            const term = inputBusca.value.toLowerCase();
            const de = inputDe.value;
            const ate = inputAte.value;

            const filtered = lancamentos.filter(l => {
                // 1. Term Match
                const valStr = (l.valor_documento || l.valor || 0).toString();
                const numDoc = (l.num_doc || l.detalhes?.num_doc || '').toString().toLowerCase();

                const matchTerm = (l.descricao || '').toLowerCase().includes(term) ||
                    (l.parceiros?.nome || '').toLowerCase().includes(term) ||
                    numDoc.includes(term) ||
                    valStr.includes(term.replace(',', '.')); // Support comma for decimals

                // 2. Pending Match (if checked, only show items NOT archived AND NOT CLOUD)
                const isArquivado = l.detalhes && l.detalhes.arquivado === true;
                let matchArq = true;
                if (onlyPending) {
                    const tipoDoc = l.detalhes ? l.detalhes.tipo_doc : '';
                    const needsPhysical = (tipoDoc && (tipoDoc.includes('Fiscal') || tipoDoc.includes('NFe'))) || (!tipoDoc && l.num_doc);

                    if (!needsPhysical) matchArq = false; // Hide Cloud items
                    else if (isArquivado) matchArq = false; // Hide already archived
                }

                // 3. Date Match (Emissao)
                let matchDate = true;
                const dataRef = l.data_emissao || (l.data_vencimento ? l.data_vencimento.split('T')[0] : '');
                if (de && dataRef < de) matchDate = false;
                if (ate && dataRef > ate) matchDate = false;

                return matchTerm && matchArq && matchDate;
            });

            currentList = filtered;
            document.getElementById('lista-lancamentos-body').innerHTML = this.renderRowsHTML(filtered);
        };

        if (inputBusca) inputBusca.addEventListener('input', aplicarFiltros);
        if (inputDe) inputDe.addEventListener('change', aplicarFiltros);
        if (inputAte) inputAte.addEventListener('change', aplicarFiltros);

        if (btnFiltroArq) {
            btnFiltroArq.addEventListener('click', () => {
                onlyPending = !onlyPending;

                // Visual Toggle
                if (onlyPending) {
                    btnFiltroArq.style.background = '#fef3c7'; // Amber-100
                    btnFiltroArq.style.color = '#d97706'; // Amber-600
                    btnFiltroArq.style.borderColor = '#d97706';
                    btnFiltroArq.innerHTML = '<i class="fas fa-folder-open"></i> Mostrando Pendentes';
                } else {
                    btnFiltroArq.style.background = 'white';
                    btnFiltroArq.style.color = '#6b7280';
                    btnFiltroArq.style.borderColor = '#d1d5db';
                    btnFiltroArq.innerHTML = '<i class="far fa-folder"></i> Pendentes Arq.';
                }

                aplicarFiltros();
            });
        }

        if (btnInbox) {
            btnInbox.addEventListener('click', () => {
                this.renderInboxSefaz();
            });
            // Update badge count
            this.checkSefazCount();
        }

        if (btnCert) {
            btnCert.addEventListener('click', () => {
                // Clear active tab
                document.querySelectorAll('.submenu-item').forEach(t => t.classList.remove('active'));

                // Render Certificados
                if (window.FazendaRP.Pages.financeiro.renderCertificados) {
                    window.FazendaRP.Pages.financeiro.renderCertificados(container);
                } else {
                    // Lazy load if module not present? (Should apply JS)
                    // Just prompt
                    alert('Módulo de certificados não carregado. Recarregue a página.');
                }
            });
        }

        if (btnPrint) {
            btnPrint.addEventListener('click', () => {
                const de = inputDe.value;
                const ate = inputAte.value;
                let pText = "Todos os registros";
                if (de && ate) pText = `Período: ${de.split('-').reverse().join('/')} a ${ate.split('-').reverse().join('/')}`;
                else if (de) pText = `A partir de: ${de.split('-').reverse().join('/')}`;
                else if (ate) pText = `Até: ${ate.split('-').reverse().join('/')}`;

                this.imprimirRelatorioLancamentos(currentList, pText);
            });
        }

        const btnExport = document.getElementById('btn-export-lanc');
        if (btnExport) {
            btnExport.addEventListener('click', () => {
                this.exportarLancamentosCSV(currentList);
            });
        }

        // Listeners for Edit/Delete/Archive
        const tbody = document.getElementById('lista-lancamentos-body');
        if (tbody) {
            tbody.addEventListener('click', async (e) => {
                const btnEdit = e.target.closest('.btn-edit-lanc');
                const btnDup = e.target.closest('.btn-dup-lanc');
                const btnDel = e.target.closest('.btn-delete-lanc');

                // VER ANEXOS
                const btnDocs = e.target.closest('.btn-view-docs');
                if (btnDocs) {
                    e.stopPropagation();
                    const docs = JSON.parse(btnDocs.dataset.docs || '[]');
                    if (docs.length > 0) {
                        const modalId = 'modal-docs-view';
                        let modal = document.getElementById(modalId);
                        if (modal) modal.remove();

                        const listHtml = docs.map(d => `
                            <div style="padding:10px; border-bottom:1px solid #eee;">
                                <a href="${d.url}" target="_blank" style="text-decoration:none; color:#0f766e; font-weight:500; display:flex; align-items:center; gap:8px;">
                                    <i class="fas fa-file-alt"></i> ${d.name} <i class="fas fa-external-link-alt" style="font-size:0.7em; opacity:0.6;"></i>
                                </a>
                            </div>
                        `).join('');

                        modal = document.createElement('div');
                        modal.id = modalId;
                        modal.style.cssText = "position:fixed; top:0; left:0; width:100%; height:100%; background:rgba(0,0,0,0.5); z-index:9999; display:flex; align-items:center; justify-content:center;";
                        modal.innerHTML = `
                            <div style="background:white; width:600px; max-width:90%; padding:20px; border-radius:8px; box-shadow:0 10px 25px rgba(0,0,0,0.2);">
                                <div style="display:flex; justify-content:space-between; margin-bottom:15px;">
                                    <h3 style="margin:0;">Documentos</h3>
                                    <button onclick="document.getElementById('${modalId}').remove()" style="border:none; bg:none; cursor:pointer; font-size:1.2rem;">&times;</button>
                                </div>
                                <div style="word-break: break-all;">
                                    ${listHtml}
                                </div>
                            </div>
                        `;
                        modal.onclick = (ev) => { if (ev.target === modal) modal.remove(); };
                        document.body.appendChild(modal);
                    }
                    return;
                }

                // EDITAR
                if (btnEdit) {
                    const id = btnEdit.dataset.id;
                    if (window.FazendaRP.Pages.financeiro) window.FazendaRP.Pages.financeiro._pendingEditId = id;
                    this.renderTabContent('novo-lancamento');
                }

                // DUPLICAR / COPIAR DADOS (CLIPBOARD)
                if (btnDup) {
                    const id = btnDup.dataset.id;
                    const btnIcon = btnDup.querySelector('i');

                    // Visual Feedback
                    if (btnIcon) btnIcon.className = "fas fa-spinner fa-spin";

                    try {
                        const { data: fullL, error } = await window.FazendaRP.supabase
                            .from('financeiro_lancamentos')
                            .select('*')
                            .eq('id', id)
                            .single();

                        if (fullL && !error) {
                            // Salvar no SessionStorage (Clipboard)
                            sessionStorage.setItem('fazenda_erp_clipboard', JSON.stringify(fullL));

                            window.FazendaRP.Toast.show('success', 'Copiado!', 'Dados na memória. Agora você pode excluir este lançamento e usar o botão "Colar Dados" em um Novo.');

                            // Restore Icon temporarily to check
                            if (btnIcon) btnIcon.className = "fas fa-check";
                            setTimeout(() => { if (btnIcon) btnIcon.className = "fas fa-copy"; }, 2000);

                        } else {
                            window.FazendaRP.Toast.show('error', 'Erro', 'Falha ao buscar dados.');
                            if (btnIcon) btnIcon.className = "fas fa-copy";
                        }
                    } catch (err) {
                        console.error(err);
                        if (btnIcon) btnIcon.className = "fas fa-copy";
                    }
                }

                // EXCLUIR
                if (btnDel) {
                    const id = btnDel.dataset.id;
                    const status = btnDel.dataset.status;

                    if (status === 'Pago') {
                        alert('⛔ Ação Bloqueada!\n\nEste lançamento já está PAGO.\nPara excluir, você deve primeiro excluir a Movimentação Financeira correspondente na aba "Movimentações".\nIsso estornará o valor ao caixa e permitirá a exclusão.');
                        return;
                    }

                    if (confirm('Tem certeza que deseja excluir este lançamento permanentemente?')) {
                        const btnIcon = btnDel.querySelector('i');
                        if (btnIcon) btnIcon.className = "fas fa-spinner fa-spin";

                        try {
                            // CHAMADA UNIFICADA (Wipe Total - Agora sem apagar pagamentos se for pago)
                            const result = await this.deletarLancamentoCompleto(id);

                            if (result.success) {
                                window.FazendaRP.Toast.show('success', 'Sucesso', 'Lançamento e todos os vínculos excluídos.');
                                // Recarrega a lista
                                this.renderListaLancamentos(container);
                            }
                        } catch (err) {
                            console.error(err);
                            alert('Erro ao excluir: ' + err.message);
                            if (btnIcon) btnIcon.className = "fas fa-trash";
                        }
                    }
                }

                // TOGGLE ARQUIVO (Physical Doc Control)
                const btnArq = e.target.closest('.btn-toggle-arquivo');
                if (btnArq) {
                    e.stopPropagation();
                    const id = btnArq.dataset.id;
                    // Current check
                    const currentStatus = btnArq.dataset.arquivado === 'true';
                    const newStatus = !currentStatus;
                    const lanc = lancamentos.find(l => l.id == id);

                    if (lanc) {
                        const newDetalhes = { ...(lanc.detalhes || {}), arquivado: newStatus };

                        // Optimistic UI Update
                        btnArq.innerHTML = '<i class="fas fa-spinner fa-spin"></i>';

                        const { error } = await window.FazendaRP.supabase
                            .from('financeiro_lancamentos')
                            .update({ detalhes: newDetalhes })
                            .eq('id', id);

                        if (error) {
                            window.FazendaRP.Toast.show('error', 'Erro', 'Falha ao atualizar arquivo.');
                            this.renderListaLancamentos(container); // Revert
                        } else {
                            lanc.detalhes = newDetalhes; // Update local state logic

                            // Visual Feedback
                            if (newStatus) {
                                btnArq.innerHTML = '<i class="fas fa-folder" style="font-size:1.1rem;"></i>';
                                btnArq.style.color = '#16a34a';
                                btnArq.dataset.arquivado = 'true';
                                btnArq.title = "Arquivado na Pasta Física";
                                window.FazendaRP.Toast.show('success', 'Arquivado', 'Impresso e guardado.');
                            } else {
                                btnArq.innerHTML = '<i class="far fa-folder" style="font-size:1.1rem;"></i>';
                                btnArq.style.color = '#9ca3af';
                                btnArq.dataset.arquivado = 'false';
                                btnArq.title = "Pendente de Arquivo Físico";
                            }
                        }
                    }
                }
            });
        }
    },

    exportarLancamentosCSV: function (lista) {
        if (!lista || lista.length === 0) {
            alert("Não há dados para exportar.");
            return;
        }

        const btn = document.getElementById('btn-export-lanc');
        const oldHtml = btn.innerHTML;
        btn.disabled = true;
        btn.innerHTML = '<i class="fas fa-spinner fa-spin"></i> ...';

        try {
            let csvContent = "Emissao;Vencto;Documento;Descrição;Parceiro;Conta;Categoria;Status;Valor\n";

            lista.forEach(l => {
                const emissao = l.data_emissao ? l.data_emissao.split('-').reverse().join('/') : '-';
                const vencto = l.data_vencimento ? l.data_vencimento.split('T')[0].split('-').reverse().join('/') : '-';
                const doc = (l.num_doc || l.detalhes?.num_doc || '-').toString().replace(/;/g, ',');
                const desc = (l.descricao || '-').replace(/;/g, ',').replace(/\n/g, ' ');
                const parceiro = (l.parceiros ? l.parceiros.nome : '-').replace(/;/g, ',');
                const conta = (l.financeiro_contas ? l.financeiro_contas.nome : '-').replace(/;/g, ',');

                let catDisplay = l.categoria ? l.categoria.split('-').pop().trim() : '-';
                catDisplay = catDisplay.replace(/^[🟣○0-9\.\s]+/, '').trim().replace(/;/g, ',');

                const status = l.status || 'Pendente';
                const val = (parseFloat(l.valor_documento || l.valor || 0)).toString().replace('.', ',');

                csvContent += `${emissao};${vencto};${doc};${desc};${parceiro};${conta};${catDisplay};${status};${val}\n`;
            });

            const blob = new Blob(["\ufeff" + csvContent], { type: 'text/csv;charset=utf-8;' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.setAttribute("href", url);
            link.setAttribute("download", `lancamentos_financeiros_${new Date().toISOString().slice(0, 10)}.csv`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

        } catch (err) {
            console.error(err);
            alert("Erro ao exportar: " + err.message);
        } finally {
            if (btn) {
                btn.disabled = false;
                btn.innerHTML = oldHtml;
            }
        }
    },

    imprimirRelatorioLancamentos: function (lista, periodoTexto) {
        if (!lista || lista.length === 0) {
            alert("Não há dados para imprimir.");
            return;
        }

        const logoDataUrl = window.FazendaRP_Logo || "";
        const now = new Date();

        let totalReceita = 0;
        let totalDespesa = 0;

        const rows = lista.map(l => {
            const isReceita = l.tipo === 'Receita';
            const val = parseFloat(l.valor_documento || l.valor || 0);

            if (isReceita) totalReceita += val;
            else totalDespesa += val;

            const dt = l.data_emissao ? l.data_emissao.split('-').reverse().join('/') : '-';
            const parceiro = l.parceiros ? l.parceiros.nome : '-';
            const desc = l.descricao || '-';
            const conta = l.financeiro_contas ? l.financeiro_contas.nome : '-';

            // Clean Categoria
            let catDisplay = l.categoria ? l.categoria.split('-').pop().trim() : '-';

            const status = l.status || 'Pendente';
            const colorStatus = status === 'Pago' ? 'green' : (status === 'Atrasado' ? 'red' : 'orange');

            const styleValor = isReceita ? 'color:#059669' : 'color:#dc2626';
            const sign = isReceita ? '+' : '-';

            return `
                <tr>
                    <td>${dt}</td>
                    <td>${l.num_doc || '-'}</td>
                    <td><div style="font-weight:600;">${desc}</div> <small style="color:#666;">${catDisplay}</small></td>
                    <td>${parceiro}</td>
                    <td>${conta}</td>
                    <td style="text-align:center;"><span style="color:${colorStatus}; font-size:11px; font-weight:bold; border:1px solid ${colorStatus}; padding:2px 4px; border-radius:4px;">${status}</span></td>
                    <td style="text-align:right; font-weight:600; ${styleValor}">${sign} ${val.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                </tr>
            `;
        }).join('');

        const saldo = totalReceita - totalDespesa;
        const colorSaldo = saldo >= 0 ? '#059669' : '#dc2626';

        const win = window.open('', '_blank');
        win.document.write(`
            <html>
            <head>
                <base href="${window.location.origin}${window.location.pathname}">
                <title>Relatório de Lançamentos</title>
                <style>
                    body { font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 13px; color: #333; padding: 20px; }
                    /* Landscape Mode */
                    @page { size: landscape; margin: 10mm; }

                    /* Header Styles */
                    .header-container { display: flex; justify-content: space-between; align-items: center; border-bottom: 3px solid #047857; padding-bottom: 15px; margin-bottom: 20px; }
                    .header-left { display: flex; align-items: center; gap: 15px; }
                    .header-left img { height: 60px; width: auto; }
                    .header-text h1 { margin: 0; font-size: 24px; color: #065f46; letter-spacing: -0.5px; }
                    .header-text h2 { margin: 5px 0 0; font-size: 16px; color: #6b7280; font-weight: 500; }
                    .header-right { text-align: right; font-size: 12px; color: #6b7280; }

                    /* Table Styles */
                    table { width: 100%; border-collapse: collapse; margin-top: 10px; }
                    th { text-align: left; background-color: #065f46; color: white; padding: 8px 10px; font-size: 12px; text-transform: uppercase; font-weight: 600; }
                    td { padding: 8px 10px; font-size: 12px; vertical-align: top; border-bottom: 1px solid #e5e7eb; }
                    tr:nth-child(even) { background-color: #f9fafb; }

                    /* Summary Boxes */
                    .summary-container { display: flex; justify-content: flex-end; gap: 20px; margin-top: 30px; }
                    .summary-box { 
                        background: #f9fafb; border: 1px solid #e5e7eb; border-radius: 8px; padding: 15px; min-width: 200px;
                        display: flex; flex-direction: column; align-items: flex-end;
                    }
                    .sum-label { font-size: 11px; color: #6b7280; text-transform: uppercase; font-weight: 600; letter-spacing: 0.5px; margin-bottom: 5px; }
                    .sum-value { font-size: 18px; font-weight: bold; }

                    @media print {
                         body { padding: 0; -webkit-print-color-adjust: exact; }
                         th { background-color: #065f46 !important; color: white !important; }
                    }
                </style>
            </head>
            <body>
                <div class="header-container">
                    <div class="header-left">
                        <img src="${logoDataUrl}" alt="Logo">
                        <div class="header-text">
                            <h1>${window.FazendaRP_NomeFazenda || 'Fazenda Rio do Peixe'}</h1>
                            <h2>Relatório de Lançamentos</h2>
                        </div>
                    </div>
                    <div class="header-right">
                        <strong>Emissão:</strong> ${now.toLocaleString('pt-BR')} <br>
                        ${periodoTexto}
                    </div>
                </div>

                <table>
                    <thead>
                        <tr>
                            <th width="8%">Emissão</th>
                            <th width="8%">Doc</th>
                            <th width="25%">Descrição / Categoria</th>
                            <th width="20%">Parceiro</th>
                            <th width="12%">Conta</th>
                            <th width="10%" style="text-align:center;">Status</th>
                            <th width="15%" style="text-align:right;">Valor</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${rows}
                    </tbody>
                </table>

                <div class="summary-container">
                    <div class="summary-box">
                        <div class="sum-label">Total Receitas</div>
                        <div class="sum-value" style="color: #059669;">${totalReceita.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</div>
                    </div>
                    <div class="summary-box">
                        <div class="sum-label">Total Despesas</div>
                        <div class="sum-value" style="color: #dc2626;">${totalDespesa.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</div>
                    </div>
                    <div class="summary-box" style="border-color: ${saldo >= 0 ? '#d1fae5' : '#fee2e2'}; background-color: ${saldo >= 0 ? '#f0fdf4' : '#fef2f2'};">
                        <div class="sum-label">Saldo do Relatório</div>
                        <div class="sum-value" style="color: ${colorSaldo};">${saldo.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</div>
                    </div>
                </div>
                <script>
                    window.onload = function() { window.print(); window.close(); }
                </script>
            </body>
            </html>
        `);
        win.document.close();
    },

    renderRowsHTML: function (lista) {
        if (!lista || lista.length === 0) {
            return '<tr><td colspan="9" style="text-align: center; color: var(--text-muted); padding: 20px;">Não há lançamentos.</td></tr>';
        }
        return lista.map(l => {
            const isReceita = l.tipo === 'Receita';
            const styleValor = isReceita ? 'color:#2e7d32' : 'color:#c62828';
            const signal = !isReceita ? '-' : '';
            const parceiroNome = l.parceiros ? l.parceiros.nome : '-';
            const contaNome = l.financeiro_contas ? l.financeiro_contas.nome : '-';

            // Fix Date Priority: Emissao -> Vencimento -> -
            const dataFmt = l.data_emissao
                ? l.data_emissao.split('-').reverse().join('/')
                : (l.data_vencimento ? l.data_vencimento.split('T')[0].split('-').reverse().join('/') : '-');

            // Badge Color
            let badgeClass = 'badge-secondary'; // Cinza default
            if (l.status === 'Pago') badgeClass = 'badge-success';
            else if (l.status === 'Pendente') badgeClass = 'badge-warning';
            else if (l.status === 'Atrasado') badgeClass = 'badge-danger';

            // Arquivo Status UI logic
            // Regra: Apenas NFe precisa de arquivo Físico (Pasta). Outros são Nuvem (Digital).
            const tipoDoc = l.detalhes ? l.detalhes.tipo_doc : '';
            // const isNFe = tipoDoc === 'Nota Fiscal (NFe)' || (l.num_doc && !tipoDoc); // Assume NFe se tem NumDoc mas sem tipo definido (legado)? Ou default para Nuvem? 
            // Melhor: Se tipoDoc for explicitamente NFe ou vazio (assumindo fiscal). Se for 'Recibo', 'Boleto' -> Nuvem.
            // Vamos simplificar: Se contiver 'Fiscal' ou 'NFe' -> Pasta. Senão -> Nuvem.
            const needsPhysical = (tipoDoc && (tipoDoc.includes('Fiscal') || tipoDoc.includes('NFe'))) || (!tipoDoc && l.num_doc);

            const isArquivado = l.detalhes && l.detalhes.arquivado === true;

            let arqBtnHtml = '';

            if (needsPhysical) {
                // Lógica da Pasta (Físico)
                const arqIcon = isArquivado ? 'fas fa-folder' : 'far fa-folder';
                const arqColor = isArquivado ? '#16a34a' : '#9ca3af'; // Green vs Gray
                const arqTitle = isArquivado ? 'Documento Físico Arquivado' : 'Marcar como Arquivado';

                arqBtnHtml = `
                    <button class="btn-icon btn-toggle-arquivo" data-id="${l.id}" data-arquivado="${isArquivado}" title="${arqTitle}" style="color:${arqColor}; border:none; background:none; cursor:pointer;">
                        <i class="${arqIcon}" style="font-size:1.1rem;"></i>
                    </button>
                `;
            } else {
                // Lógica da Nuvem (Digital Only)
                arqBtnHtml = `
                    <span title="Documento Digital (Nuvem)" style="color:#3b82f6; cursor:help;">
                        <i class="fas fa-cloud" style="font-size:1.1rem; opacity:0.7;"></i>
                    </span>
                `;
            }

            // Clean Categoria Logic
            const cleanCat = (c) => {
                if (!c) return '';
                let parts = c.split(' - ');
                let nome = parts.length > 1 ? parts[parts.length - 1] : c;
                return nome.replace(/^[🟣○0-9\.\s]+/, '').trim();
            };

            let catDisplay = cleanCat(l.categoria); // Default

            // If has items with categories, aggregate them
            if (l.detalhes && l.detalhes.itens && Array.isArray(l.detalhes.itens) && l.detalhes.itens.length > 0) {
                const allCats = l.detalhes.itens.map(i => cleanCat(i.categoria)).filter(c => c);
                const uniqueCats = [...new Set(allCats)]; // Unique

                if (uniqueCats.length > 0) {
                    const show = uniqueCats.slice(0, 3).join(', ');
                    catDisplay = show + (uniqueCats.length > 3 ? '...' : '');
                }
            }

            return `
            <tr class="tr-hover">
                <td>${dataFmt}</td>
                <td><small style="color:#666;">${l.num_doc || l.detalhes?.num_doc || '-'}</small></td>
                <td>
                    <strong style="color:#555;">${l.descricao}</strong>
                    ${(l.anexos && l.anexos.length > 0) ? `<i class="fas fa-paperclip btn-view-docs" data-docs='${JSON.stringify(l.anexos).replace(/'/g, "&apos;")}' style="margin-left:8px; color:#0ea5e9; cursor:pointer;" title="Ver ${l.anexos.length} documento(s)"></i>` : ''}
                </td>
                <td>${parceiroNome}</td>
                <td>${catDisplay || '-'}</td>
                 <td>${contaNome}</td>
                <td style="${styleValor}; font-weight:600; white-space:nowrap;">R$ ${(parseFloat(l.valor_documento || l.valor)).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</td>
                <td><span class="badge ${badgeClass}">${l.status || 'Pendente'}</span></td>
                <td style="text-align:center;">
                    ${arqBtnHtml}
                </td>
                <td style="text-align:right;">
                    ${l.status === 'Pago'
                    ? `<button class="btn-icon btn-edit-lanc" data-id="${l.id}" title="Editar (Restrito: Anexos/Obs)" style="color:var(--color-warning);"><i class="fas fa-edit"></i></button>`
                    : `<button class="btn-icon btn-edit-lanc" data-id="${l.id}" title="Editar" style="color:#6b7280;"><i class="fas fa-edit"></i></button>`
                }
                    <button class="btn-icon btn-dup-lanc" data-id="${l.id}" title="Duplicar / Copiar dados" style="color:#0f766e;"><i class="fas fa-copy"></i></button>
                    <button class="btn-icon btn-delete-lanc" data-id="${l.id}" data-status="${l.status || 'Pendente'}" title="Excluir" style="color: #dc2626;"><i class="fas fa-trash"></i></button>
                </td>
            </tr>
            `;
        }).join('');
    },

    checkSefazCount: async function () {
        const { count, error } = await window.FazendaRP.supabase
            .from('financeiro_pre_lancamentos')
            .select('*', { count: 'exact', head: true })
            .eq('origem_tipo', 'sefaz')
            .eq('status', 'pendente');

        const badge = document.getElementById('badge-sefaz');
        if (badge && count > 0) {
            badge.innerText = count;
            badge.style.display = 'inline-block';
        }
    },

    renderInboxSefaz: async function () {
        // Modal Logic
        const modalId = 'modal-inbox-sefaz';
        let modal = document.getElementById(modalId);
        if (modal) modal.remove();

        modal = document.createElement('div');
        modal.id = modalId;
        modal.style.cssText = "position:fixed; top:0; left:0; width:100%; height:100%; background:rgba(0,0,0,0.5); z-index:9999; display:flex; align-items:center; justify-content:center;";
        modal.innerHTML = `
            <div style="background:white; width:900px; max-width:95%; height:80vh; display:flex; flex-direction:column; border-radius:8px; box-shadow:0 10px 25px rgba(0,0,0,0.2);">
                <div style="padding:20px; border-bottom:1px solid #eee; display:flex; justify-content:space-between; align-items:center; background:#f8fafc;">
                    <div style="display:flex; align-items:center; gap:10px;">
                        <i class="fas fa-inbox" style="font-size:1.5rem; color:#2563eb;"></i>
                        <div>
                            <h3 style="margin:0; color:#1e293b;">Caixa de Entrada SEFAZ</h3>
                            <div style="font-size:0.85rem; color:#64748b;">Notas fiscais emitidas contra seu CPF/CNPJ</div>
                        </div>
                    </div>
                    <div style="display:flex; gap:10px;">
                        <button id="btn-sync-sefaz" class="btn btn-primary" style="background:#2563eb; font-size:0.9rem;">
                            <i class="fas fa-sync"></i> Buscar Novas
                        </button>
                        <button onclick="document.getElementById('${modalId}').remove()" style="border:none; bg:none; cursor:pointer; font-size:1.5rem; color:#94a3b8;">&times;</button>
                    </div>
                </div>
                
                <div id="inbox-list" style="flex:1; overflow-y:auto; padding:20px; background:#f1f5f9;">
                    <div style="text-align:center; padding:40px;"><i class="fas fa-spinner fa-spin"></i> Carregando notas...</div>
                </div>
            </div>
        `;
        document.body.appendChild(modal);

        const loadList = async () => {
            const listDiv = modal.querySelector('#inbox-list');
            listDiv.innerHTML = '<div style="text-align:center; padding:40px;"><i class="fas fa-spinner fa-spin"></i> Carregando notas...</div>';

            const { data, error } = await window.FazendaRP.supabase
                .from('financeiro_pre_lancamentos')
                .select('*')
                .eq('origem_tipo', 'sefaz')
                .eq('status', 'pendente')
                .order('created_at', { ascending: false });

            if (error) {
                listDiv.innerHTML = `<div style="color:red; text-align:center;">Erro: ${error.message}</div>`;
                return;
            }

            if (!data || data.length === 0) {
                listDiv.innerHTML = `
                    <div style="text-align:center; padding:50px; color:#64748b;">
                        <i class="fas fa-check-circle" style="font-size:3rem; color:#cbd5e1; margin-bottom:15px;"></i>
                        <br>Tudo limpo! Nenhuma nota pendente.
                    </div>
                `;
                return;
            }

            listDiv.innerHTML = data.map(item => {
                const dados = item.dados_extraidos || {};
                const dataEmissao = dados.data_emissao ? new Date(dados.data_emissao).toLocaleDateString('pt-BR') : '-';
                const valor = parseFloat(dados.valor_total || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

                return `
                    <div style="background:white; padding:15px; border-radius:8px; margin-bottom:10px; border:1px solid #e2e8f0; display:flex; justify-content:space-between; align-items:center; box-shadow:0 1px 2px rgba(0,0,0,0.05);">
                        <div style="display:flex; gap:15px; align-items:center;">
                            <div style="background:#eff6ff; color:#2563eb; padding:10px; border-radius:50%;">
                                <i class="fas fa-file-invoice"></i>
                            </div>
                            <div>
                                <div style="font-weight:600; color:#334155;">${dados.emitente_nome || 'Desconhecido'}</div>
                                <div style="font-size:0.85rem; color:#64748b;">CNPJ: ${dados.emitente_cnpj || '-'} | Chave: <span title="${dados.chave}">${(dados.chave || '').substring(0, 20)}...</span></div>
                            </div>
                        </div>
                        <div style="text-align:right; margin-right:20px;">
                            <div style="font-weight:bold; color:#0f172a; font-size:1.1rem;">${valor}</div>
                            <div style="font-size:0.8rem; color:#64748b;">${dataEmissao}</div>
                        </div>
                        <div>
                            <button class="btn-process-sefaz" data-id="${item.id}" style="background:#22c55e; color:white; border:none; padding:8px 16px; border-radius:6px; cursor:pointer; font-weight:500; display:flex; align-items:center; gap:5px;">
                                <i class="fas fa-check"></i> Processar
                            </button>
                        </div>
                    </div>
                `;
            }).join('');

            // Bind Actions
            listDiv.querySelectorAll('.btn-process-sefaz').forEach(btn => {
                btn.onclick = async () => {
                    const id = btn.dataset.id;
                    const item = data.find(d => d.id == id);
                    if (item) {
                        modal.remove(); // Close Inbox
                        this.openProcessForm(item); // Open CRUD
                    }
                };
            });
        };

        // Sync Action (Call Bot)
        // Since we can't call 'node' from here, we rely on the bot being running. 
        // But for this "Mock", we can simulate calling the service or simply re-load if the bot runs periodically.
        // User asked for "Bot updates". Let's assume bot runs on schedule. 
        // Or we can just prompt: "O Bot buscará novas notas em instantes."
        const btnSync = modal.querySelector('#btn-sync-sefaz');
        btnSync.onclick = () => {
            btnSync.disabled = true;
            btnSync.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Buscando...';
            // Simular delay
            setTimeout(() => {
                window.FazendaRP.Toast.show('info', 'Sincronização', 'Solicitação enviada ao Bot. Atualize em alguns instantes.');
                btnSync.disabled = false;
                btnSync.innerHTML = '<i class="fas fa-sync"></i> Buscar Novas';
                loadList();
            }, 2000);
        };

        loadList();
    },

    openProcessForm: function (preLaunchItem) {
        // Open Form and Pre-Fill
        // 1. Switch to 'novo-lancamento' tab
        if (window.FazendaRP.Pages.financeiro && window.FazendaRP.Pages.financeiro.renderTabContent) {
            document.querySelectorAll('.submenu-item').forEach(t => t.classList.remove('active'));
            document.querySelector('.submenu-item[data-tab="novo-lancamento"]')?.classList.add('active');
            window.FazendaRP.Pages.financeiro.renderTabContent('novo-lancamento');

            // 2. Wait render then populate
            setTimeout(() => {
                const formContainer = document.getElementById('financeiro-content');
                const dados = preLaunchItem.dados_extraidos || {};

                // Pre-Fill Logic
                const descInput = formContainer.querySelector('#desc-sem-itens'); // Assume 'sem_itens' or 'com_itens' based on parsing?
                // Ideally force 'com_itens' if we have items
                const modoRadio = formContainer.querySelector('input[name="modo_lancamento"][value="com_itens"]');
                if (modoRadio) {
                    modoRadio.checked = true;
                    modoRadio.dispatchEvent(new Event('change'));
                }

                // Set Data
                if (dados.data_emissao) {
                    formContainer.querySelector('#data-emissao').value = dados.data_emissao.split('T')[0];
                    formContainer.querySelector('#data-vencimento').value = dados.data_emissao.split('T')[0];
                }

                // Set Num Doc
                // Extract 'nNF' from Chave or XML? Mock has no nNF, use last digits of Chave
                const nNF = dados.chave ? dados.chave.substring(25, 34) : ''; // Rough guess
                formContainer.querySelector('#num-documento').value = parseInt(nNF) || '';
                formContainer.querySelector('#tipo-documento').value = 'NF';

                // Set Description
                if (descInput) descInput.value = `NFe ${dados.emitente_nome}`;

                // Set Parceiro (Search by CNPJ or Name)
                // This requires searching the list. 
                // For now, let's just put info in Obs
                formContainer.querySelector('#obs-lancamento').value = `[IMPORTADO SEFAZ] Emitente: ${dados.emitente_nome} (${dados.emitente_cnpj}). Chave: ${dados.chave}`;

                // Set ID of Pre-Launch to link on Save
                // We need a hidden field for this connection!
                // Add hidden input dynamically if not exists
                let preIdInput = formContainer.querySelector('#pre-lancamento-id');
                if (!preIdInput) {
                    preIdInput = document.createElement('input');
                    preIdInput.type = 'hidden';
                    preIdInput.id = 'pre-lancamento-id';
                    formContainer.appendChild(preIdInput);
                }
                preIdInput.value = preLaunchItem.id;

                window.FazendaRP.Toast.show('info', 'Importação', 'Dados carregados da NFe. Verifique e salve.');

            }, 500);
        }
    }
});

